import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";
import { Lock } from "lucide-react";

export default function PrivacyPage() {
  return (
    <>
      <PublicHeader />
      <main className="max-w-4xl mx-auto px-4 py-10 pb-24" data-testid="privacy-page">
        <div className="tag-cat mb-4">गोपनीयता नीति</div>
        <h1 className="font-devnagri-heading text-4xl sm:text-5xl font-black text-[#0F172A] leading-tight flex items-center gap-3">
          <Lock className="w-10 h-10 text-sky-600"/>Privacy Policy
        </h1>
        <p className="text-slate-500 mt-2 text-sm">अंतिम अपडेट: {new Date().toLocaleDateString("hi-IN", { year: "numeric", month: "long", day: "numeric" })}</p>

        <div className="prose prose-slate max-w-none mt-6 space-y-5 text-slate-700 leading-relaxed">
          <p><b>INDIAN-NEWS-21</b> (आगे "हम", "हमारा", "पोर्टल") अपने पाठकों की व्यक्तिगत जानकारी की गोपनीयता का पूरा सम्मान करता है। यह नीति बताती है कि हम कौन-सी जानकारी एकत्र करते हैं, उसका उपयोग कैसे करते हैं, और आपके क्या अधिकार हैं।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">1. एकत्र की जाने वाली जानकारी</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li><b>स्वेच्छा से दी गई जानकारी:</b> जब आप संपर्क फ़ॉर्म भरते हैं, newsletter सब्सक्राइब करते हैं, comment करते हैं या "Reader Contribution" जमा करते हैं — नाम, ईमेल, फ़ोन, शहर, और आपका संदेश/फ़ोटो।</li>
            <li><b>स्वचालित रूप से एकत्रित:</b> IP पता, ब्राउज़र प्रकार, डिवाइस, ऑपरेटिंग सिस्टम, referrer URL, विज़िट का समय — तकनीकी विश्लेषण एवं सुरक्षा के लिए।</li>
            <li><b>Cookies एवं समान तकनीक:</b> पाठक अनुभव सुधारने, प्राथमिकताएँ याद रखने, और विज्ञापन सेवा के लिए।</li>
          </ul>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">2. जानकारी का उपयोग</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>आपको newsletter, breaking news alerts और अन्य updates भेजने के लिए (केवल आपकी सहमति से)</li>
            <li>पाठक अनुभव को व्यक्तिगत बनाने के लिए</li>
            <li>वेबसाइट analytics एवं trend रिपोर्टिंग</li>
            <li>तकनीकी सुरक्षा, धोखाधड़ी की रोकथाम, कानूनी अनुपालन</li>
            <li>Reader Contribution संबंधी संचार (सिफ़ारिश, प्रकाशन सूचना, आदि)</li>
          </ul>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">3. जानकारी साझा करना</h2>
          <p>हम आपकी व्यक्तिगत जानकारी किसी भी तीसरे पक्ष को बेचते या किराए पर नहीं देते। जानकारी केवल तभी साझा की जाती है जब:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>आपकी स्पष्ट सहमति हो</li>
            <li>कानूनी आवश्यकता (न्यायालय आदेश, विधिक जांच) पूरी करनी हो</li>
            <li>Trusted service providers (email delivery, hosting, analytics) — जो हमारे साथ NDA पर हैं और केवल सेवा के दायरे में ही डेटा उपयोग करते हैं</li>
          </ul>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">4. Cookies एवं विज्ञापन</h2>
          <p>हम कुछ third-party विज्ञापन platforms (जैसे Google AdSense) का उपयोग कर सकते हैं जो cookies के माध्यम से आपके ब्राउज़िंग व्यवहार के आधार पर विज्ञापन दिखा सकते हैं। आप अपने ब्राउज़र settings से cookies बंद कर सकते हैं, हालांकि इससे कुछ features प्रभावित हो सकते हैं।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">5. डेटा सुरक्षा</h2>
          <p>हम आपकी जानकारी की सुरक्षा के लिए industry-standard उपाय (HTTPS एन्क्रिप्शन, secure database, नियमित backup) अपनाते हैं। हालाँकि, इंटरनेट पर 100% सुरक्षा की गारंटी संभव नहीं है।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">6. बच्चों की गोपनीयता</h2>
          <p>हमारा पोर्टल <b>13 वर्ष से कम आयु</b> के बच्चों के लिए अभिप्रेत नहीं है। हम जानबूझकर बच्चों की व्यक्तिगत जानकारी एकत्र नहीं करते। यदि आपको लगता है कि आपके बच्चे ने हमें जानकारी दी है, तो कृपया तुरंत हमसे संपर्क करें।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">7. आपके अधिकार</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>अपनी जानकारी देखने / सुधारने / मिटाने का अधिकार</li>
            <li>Newsletter/notifications से कभी भी unsubscribe करने का अधिकार</li>
            <li>Reader Contribution को हटवाने का अधिकार</li>
            <li>अपनी सहमति वापस लेने का अधिकार</li>
          </ul>
          <p>इन अधिकारों का उपयोग करने के लिए हमें <a href="mailto:mdjkbaba786@gmail.com" className="text-[#DC2626] font-bold hover:underline">mdjkbaba786@gmail.com</a> पर लिखें।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">8. नीति में बदलाव</h2>
          <p>हम इस नीति को समय-समय पर अपडेट कर सकते हैं। कोई भी महत्वपूर्ण बदलाव इसी पेज पर नई तारीख के साथ प्रकाशित किया जाएगा।</p>

          <h2 className="font-devnagri-heading text-2xl font-black text-[#0F172A] mt-8">9. संपर्क</h2>
          <p>गोपनीयता संबंधी किसी भी प्रश्न के लिए:</p>
          <div className="p-4 rounded-lg bg-slate-50 border-l-4 border-sky-600 text-sm">
            <b>Data Protection Officer</b><br/>
            प्रधान संपादक JAKIR MOMIN<br/>
            INDIAN-NEWS-21<br/>
            सिरसी नवापारा, मेन रोड, सूरजपुर, छत्तीसगढ़ — 497231<br/>
            📧 <a href="mailto:mdjkbaba786@gmail.com" className="text-[#DC2626] font-bold hover:underline">mdjkbaba786@gmail.com</a> · 📞 <a href="tel:+918463860303" className="text-[#DC2626] font-bold hover:underline">+91 8463860303</a>
          </div>
        </div>
      </main>
      <PublicFooter />
    </>
  );
}
